const camadas = [
    {
        label: 'Agropecuária',
        chaveTraducao: 'agropecuaria',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        id: 0,
        children: [
            {
                codigo: 'POC_AREA_PLANTADA_GAMELEIRA',
                nome: 'POC_AREA_PLANTADA_GAMELEIRA',
                label: 'Área plantada Gameleira',
                checkbox: true,
                layerName: 'pocs:car_plantio_gameleira',
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/pocs/wms',
                colorIcon: '#6AA84F',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREA_PLANTADA_SOJA_CAR_MAPBIOMAS',
                nome: 'AREA_PLANTADA_SOJA_CAR_MAPBIOMAS',
                label: 'Área de soja - coleção 7 - Mapbiomas',
                layerName: 'vega-api:cobertura_solo_map_biomas_2021',
                styleName: 'soja_mapbiomas_2021',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#C59FF4',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'PLANTIO_SOJA_23_MATOPIBA',
                nome: 'PLANTIO_SOJA_23_MATOPIBA',
                label: 'Plantio de Soja Safra 22/23 – MATOPIBA',
                layerName: 'vega-api-homolog:matopiba',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                colorIcon: '#6aa84f',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'PLANTIO_SOJA',
                nome: 'PLANTIO_SOJA',
                label: 'Plantio de soja',
                layerName: 'pocs:areas_plantio_soja_2020',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/pocs/wms',
                colorIcon: '#6aa84f',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'SOJA_SAFRA_2324_PARAGUAY',
                nome: 'SOJA_SAFRA_2324_PARAGUAY',
                label: 'Soja Safra 2023/2024 - Paraguay',
                layerName: 'vega-api:soja_safra_2324_paraguay',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREA_PLANTADA_SOJA_PARAGUAI_2024_2025',
                nome: 'AREA_PLANTADA_SOJA_PARAGUAI_2024_2025',
                label: 'Safra de Soja 2024/2025 - Paraguai',
                layerName: 'vega-api:soja_safra_2425',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "pais like '%Paraguai%'"
            },
            {
                codigo: 'SOJA_PARAGUAI_2022',
                nome: 'SOJA_PARAGUAI_2022',
                label: 'Soja Paraguai 2022',
                layerName: 'vega-api:soja_paraguai_2022',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREA_PLANTADA_BUNGE',
                nome: 'AREA_PLANTADA_BUNGE',
                label: 'Área plantada soja 2023/2024',
                layerName: 'vega-api:area_plantada_bunge',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREA_PLANTADA_BUNGE_2024',
                nome: 'AREA_PLANTADA_BUNGE_2024',
                label: 'Área plantada soja 2024',
                layerName: 'vega-api:area_plantada_bunge',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "codigo_safra='SAFRA_2024'"
            },
            {
                codigo: 'AREA_PLANTADA_BUNGE_2025',
                nome: 'AREA_PLANTADA_BUNGE_2025',
                label: 'Área plantada soja 2025',
                layerName: 'vega-api:area_plantada_bunge',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "codigo_safra='SAFRA_2025'"
            },
            {
                codigo: 'AREA_PLANTADA_BUNGE_2026',
                nome: 'AREA_PLANTADA_BUNGE_2026',
                label: 'Área plantada soja 2026',
                layerName: 'vega-api:area_plantada_bunge',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "codigo_safra='SAFRA_2026'"
            },
            {
                codigo: 'AREA_PLANTADA_SOJA_CAR_MAPBIOMAS_COLECAO10',
                nome: 'AREA_PLANTADA_SOJA_CAR_MAPBIOMAS_COLECAO10',
                label: 'Área de soja - coleção 10 - Mapbiomas',
                layerName: 'vega-api:car_area_plantada_soja_mapbiomas_colecao10',
                styleName: 'soja_mapbiomas_colecao10',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6EBD6D',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'FOOTPRINT_BUNGE',
                nome: 'FOOTPRINT_BUNGE',
                label: 'Footprint Bunge',
                layerName: 'vega-api:footprint_bunge',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8B4513',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'AREA_PLANTADA_SOJA_PARAGUAI_2025_2026',
                nome: 'AREA_PLANTADA_SOJA_PARAGUAI_2025_2026',
                label: 'Área plantada Safra Paraguai 2025/2026',
                layerName: 'vega-api:AREA_PLANTADA_SOJA_PARAGUAI_2025_2026',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: true
            }
        ]
    },
    {
        label: 'Cadastro Ambiental Rural',
        icon: 'mdi mdi-folder-outline',
        chaveTraducao: 'cadastroAmbientalRural',
        checkbox: false,
        id: 1,
        children: [
            {
                codigo: 'IMOVEL_RURAL',
                nome: 'IMOVEL_RURAL',
                label: 'CAR',
                layerName: 'vega-api:propriedade_rural',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                colorIcon: '#fff002',
                opacidade: 100,
                inspecionar: true,
                subtitle: []
            },
            {
                codigo: 'CARS_CLASSIFICADOS',
                nome: 'CARS_CLASSIFICADOS',
                label: 'Áreas classificadas do CAR',
                layerName: 'vega-api:cars_classificados',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                subtitle: [
                    {
                        name: 'APP',
                        colorIcon: '#e4ff15',
                        opacidade: 100
                    },
                    {
                        name: 'APP a Recompor',
                        colorIcon: '#d2ac16',
                        opacidade: 100
                    },
                    {
                        name: 'Área antropizada',
                        colorIcon: '#8a8f8e',
                        opacidade: 100
                    },
                    {
                        name: 'Área consolidada',
                        colorIcon: '#616161',
                        opacidade: 100
                    },
                    {
                        name: 'Hidrografia',
                        colorIcon: '#377eb8',
                        opacidade: 100
                    },
                    {
                        name: 'Nascente',
                        colorIcon: '#0000ff',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação nativa em APP',
                        colorIcon: '#33a02c',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação nativa em RL',
                        colorIcon: '#33a02c',
                        opacidade: 100
                    }
                ]
            },
            {
                label: 'Fundiário',
                chaveTraducao: 'fundiario',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                ativo: false,
                id: 2,
                children: [
                    {
                        codigo: 'INCRA_SIGEF_PRIVADO',
                        nome: 'INCRA_SIGEF_PRIVADO',
                        label: 'INCRA/SIGEF(Privado)',
                        layerName: 'vega-api:sigef_privado',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#b45f05',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'INCRA_SIGEF_PUBLICO',
                        nome: 'INCRA_SIGEF_PUBLICO',
                        label: 'INCRA/sigef (Público)',
                        layerName: 'vega-api:sigef_publico',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#9e7f05',
                        opacidade: 100,
                        inspecionar: true
                    }
                ],
                subtitle: []
            }
        ]
    },
    {
        label: 'Conformidade socioambiental',
        chaveTraducao: 'conformidadeSocioambiental',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        id: 3,
        children: [
            {
                codigo: 'QUEIMADAS',
                nome: 'QUEIMADAS',
                label: 'Queimadas',
                layerName: 'vega-api:queimadas',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: true,
                subtitle: []
            },
            {
                label: 'Embargos e Desmatamento',
                chaveTraducao: 'embargosDesmatamento',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                ativo: false,
                id: 4,
                children: [
                    {
                        codigo: 'AREA_EMBARGADA_GDF',
                        nome: 'AREA_EMBARGADA_GDF',
                        label: 'Áreas Embargadas - Distrito Federal (GDF)',
                        layerName: 'vega-api-homolog:area_embargada_gdf',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA',
                        nome: 'AREA_EMBARGADA',
                        label: 'Áreas Embargadas (IBAMA)',
                        layerName: 'vega-api:area_embargada',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b21d11',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_IBAMA_POLIGONO_PAMGIA',
                        nome: 'AREA_EMBARGADA_IBAMA_POLIGONO_PAMGIA',
                        label: 'Área Embargada (IBAMA) - PAMGIA',
                        layerName:
                            'vega-api:area_embargada_ibama_poligono_pamgia',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b21d11',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_SEMA_MT',
                        nome: 'AREA_EMBARGADA_SEMA_MT',
                        label: 'Áreas Embargadas (SEMA-MT)',
                        layerName: 'vega-api:area_embargada_semas_mt',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#d100c5',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'LISTA_AREA_EMBARGADA_SEMA_MT',
                        nome: 'LISTA_AREA_EMBARGADA_SEMA_MT',
                        label: 'Lista de Áreas embargadas SEMA-MT',
                        layerName: 'vega-api:area_embargada_sema_mt_lista',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b21d19',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_GOIAS',
                        nome: 'AREA_EMBARGADA_GOIAS',
                        label: 'Áreas Embargadas - GO',
                        layerName: 'vega-api:area_embargada_goias',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#99357B',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'EUDR_FOREST_COVER_2020',
                        nome: 'EUDR_FOREST_COVER_2020',
                        label: 'EU Forest Observatory',
                        layerName: 'vega-api:eudr_forest_cover_2020',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#38761d',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_PIAUI',
                        nome: 'AREA_EMBARGADA_PIAUI',
                        label: 'Áreas Embargadas Piauí',
                        layerName: 'vega-api:area_embargada_piaui',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_SEDAM_RO',
                        nome: 'AREA_EMBARGADA_SEDAM_RO',
                        label: 'Áreas Embargadas (SEDAM-RO)',
                        layerName: 'vega-api:area_embargada_sedam_ro',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_ICMBIO',
                        nome: 'AREA_EMBARGADA_ICMBIO',
                        label: 'Área embargada ICMBio',
                        layerName: 'vega-api:area_embargada_icmbio',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#c0fd79',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'CSA_CERRADO',
                        nome: 'CSA_CERRADO',
                        label: 'CSA Cerrado',
                        layerName: 'vega-api-homolog:csa_cerrado',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                        colorIcon: '#b21d11',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_2008',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2009',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2010',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2011',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2012',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2013',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2014',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2015',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2016',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2017',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2018',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2019',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2020',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2021',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2022',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2023',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_2024',
                        nome: 'PRODES',
                        label: 'PRODES',
                        layerName: 'vega-api:prodes',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: false
                    },
                    {
                        codigo: 'PRODES_CERRADO',
                        nome: 'PRODES_CERRADO',
                        label: 'PRODES Cerrado',
                        layerName: 'vega-api:prodes_cerrado',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_PANTANAL',
                        nome: 'PRODES_PANTANAL',
                        label: 'PRODES Pantanal',
                        layerName: 'vega-api:prodes_pantanal',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_MATA_ATLANTICA',
                        nome: 'PRODES_MATA_ATLANTICA',
                        label: 'PRODES Mata Atlântica',
                        layerName: 'vega-api:prodes_mata_atlantica',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_PAMPA',
                        nome: 'PRODES_PAMPA',
                        label: 'PRODES Pampa',
                        layerName: 'vega-api:prodes_pampa',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_CAATINGA',
                        nome: 'PRODES_CAATINGA',
                        label: 'PRODES Caatinga',
                        layerName: 'vega-api:prodes_caatinga',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS',
                        nome: 'PRODES_RESIDUOS',
                        label: 'PRODES Resíduos Amazônia Legal',
                        layerName: 'vega-api:prodes_residuos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_AMAZONIA',
                        nome: 'PRODES_RESIDUOS_AMAZONIA',
                        label: 'PRODES Resíduos Amazônia',
                        layerName: 'vega-api:prodes_residuos_amazonia',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_CAATINGA',
                        nome: 'PRODES_RESIDUOS_CAATINGA',
                        label: 'PRODES Resíduos Caatinga',
                        layerName: 'vega-api:prodes_residuos_caatinga',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_CERRADO',
                        nome: 'PRODES_RESIDUOS_CERRADO',
                        label: 'PRODES Resíduos Cerrado',
                        layerName: 'vega-api:prodes_residuos_cerrado',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_MATA_ATLANTICA',
                        nome: 'PRODES_RESIDUOS_MATA_ATLANTICA',
                        label: 'PRODES Resíduos Mata Atlântica',
                        layerName: 'vega-api:prodes_residuos_mata_atlantica',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_PAMPA',
                        nome: 'PRODES_RESIDUOS_PAMPA',
                        label: 'PRODES Resíduos Pampa',
                        layerName: 'vega-api:prodes_residuos_pampa',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PRODES_RESIDUOS_PANTANAL',
                        nome: 'PRODES_RESIDUOS_PANTANAL',
                        label: 'PRODES Resíduos Pantanal',
                        layerName: 'vega-api:prodes_residuos_pantanal',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_MAPBIOMAS',
                        nome: 'DESMATAMENTO_MAPBIOMAS',
                        label: 'Desmatamento MapBiomas',
                        layerName: 'vega-api:desmatamento_mapbiomas',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_INFONA_PARAGUAI',
                        nome: 'DESMATAMENTO_INFONA_PARAGUAI',
                        label: 'Desmatamento Infona Paraguai',
                        layerName: 'vega-api:desmatamento_infona_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_INFONA_PARAGUAI_2020',
                        nome: 'DESMATAMENTO_INFONA_PARAGUAI_2020',
                        label: 'Desmatamento Infona Paraguai 2020',
                        layerName: 'vega-api:desmatamento_infona_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true,
                        cql_filter: "strSubstring(periodo, 5, 9) > '2020'"
                    },
                    {
                        codigo: 'DESMATAMENTO_INFONA_PARAGUAI_2024',
                        nome: 'DESMATAMENTO_INFONA_PARAGUAI_2024',
                        label: 'Desmatamento Infona Paraguai 2024',
                        layerName: 'vega-api:desmatamento_infona_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true,
                        cql_filter: "strSubstring(periodo, 5, 9) > '2024'"
                    },
                    {
                        codigo: 'DESMATAMENTO_VEGA_COM_SOJA_2324_VEGA_PARAGUAI',
                        nome: 'DESMATAMENTO_VEGA_COM_SOJA_2324_VEGA_PARAGUAI',
                        label: 'Deforestación VEGA 2020 - 2024 con Intersección Soja Paraguay',
                        layerName: 'vega-api:desmatamento_vega_com_soja_2324_vega_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_VEGA_2025_COM_SOJA_2425_VEGA_PARAGUAI',
                        nome: 'DESMATAMENTO_VEGA_2025_COM_SOJA_2425_VEGA_PARAGUAI',
                        label: 'Intersección Soja 2024 - 2025  con Deforestación Paraguay VEGA 2020 - 2025',
                        layerName: 'vega-api:desmatamento_vega_2025_com_soja_2425_vega_paraguai',
                        checkbox: true,
                        ativo: true,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true,
                        cql_filter: 'cultura IS NOT NULL'
                    },
                    {
                        codigo: 'DESMATAMENTO_PARAGUAI_VEGA_2025',
                        nome: 'DESMATAMENTO_PARAGUAI_VEGA_2025',
                        label: 'Desmatamento Vega paraguai 2020 - 2025',
                        layerName: 'vega-api:desmatamento_paraguai_vega_2025',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_PARAGUAI_VEGA',
                        nome: 'DESMATAMENTO_PARAGUAI_VEGA',
                        label: 'Deforestación VEGA Paraguay 2020 - 2024',
                        layerName: 'vega-api:desmatamento_paraguai_vega',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'LDI',
                        nome: 'LDI',
                        label: 'LDI',
                        layerName: 'vega-api:ldi',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DETER_AMAZONIA',
                        nome: 'DETER_AMAZONIA',
                        label: 'DETER Amazônia',
                        layerName: 'vega-api:deter_amazonia',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DETER_CERRADO',
                        nome: 'DETER_CERRADO',
                        label: 'DETER Cerrado',
                        layerName: 'vega-api:deter_cerrado',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS',
                        nome: 'CONTROLE_DESMATAMENTO_AMAZONIA_PONTOS',
                        label: 'Controle Desmatamento Amazônia - pontos',
                        layerName: 'vega-api:moratoria_soja_pontos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#fff2cc',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'CONTROLE_DESMATAMENTO_AMAZONIA',
                        nome: 'CONTROLE_DESMATAMENTO_AMAZONIA',
                        label: 'Controle Desmatamento Amazônia - polígonos',
                        layerName: 'vega-api:moratoria_soja_poligonos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#e19418',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'CONTROLE_DESMATAMENTO_AMAZONIA_CONSOLIDADA',
                        nome: 'CONTROLE_DESMATAMENTO_AMAZONIA_CONSOLIDADA',
                        label: 'Controle Desmatamento Amazônia - Consolidada',
                        layerName: 'vega-api:moratoria_soja_consolidada',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#fff2cc',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'LISTA_AREA_EMBARGADA',
                        nome: 'LISTA_AREA_EMBARGADA',
                        label: 'Áreas embargadas Ibama - Lista',
                        layerName: 'vega-api:lista_area_embargada_ibama',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b21d11',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_SIGA_SEMA_MT',
                        nome: 'AREA_EMBARGADA_SIGA_SEMA_MT',
                        label: 'Áreas Embargadas SIGA/SEMA-MT',
                        layerName: 'vega-api:area_embargada_sema_siga_mt',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_PLANTADA_DESMATAMENTO_VEGA_A_PARTIR_2021',
                        nome: 'AREA_PLANTADA_DESMATAMENTO_VEGA_A_PARTIR_2021',
                        label: 'Áreas Plantadas Desmatamento Vega a partir de 2021',
                        layerName:
                            'vega-api:area_plantada_desmatamento_vega_a_partir_2021',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_SIGA_MT_POLIGONO',
                        nome: 'AREA_EMBARGADA_SIGA_MT_POLIGONO',
                        label: 'Áreas Embargadas SIGA-MT - Polígono',
                        layerName: 'vega-api:area_embargada_siga_mt_poligono',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_SIGA_MT_PONTO',
                        nome: 'AREA_EMBARGADA_SIGA_MT_PONTO',
                        label: 'Áreas Embargadas SIGA-MT - Ponto',
                        layerName: 'vega-api:area_embargada_siga_mt_ponto',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'HIDROGRAFIA',
                        nome: 'HIDROGRAFIA',
                        label: 'Hidrografia',
                        layerName: 'vega-api:hidrografia',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'FUNDACAO_PALMARES',
                        nome: 'FUNDACAO_PALMARES',
                        label: 'Fundação Palmares',
                        layerName: 'vega-api:fundacao_palmares',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#674ea7',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_PARANA',
                        nome: 'AREA_EMBARGADA_PARANA',
                        label: 'Áreas Embargadas Paraná',
                        layerName: 'vega-api:area_embargada_parana',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FF0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_AUTO_INFRACAO_SP',
                        nome: 'AREA_EMBARGADA_AUTO_INFRACAO_SP',
                        label: 'Áreas Embargadas - Autos de infração SP',
                        layerName: 'vega-api:area_embargada_auto_infracao_sp',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FF0000',
                        opacidade: 100,
                        inspecionar: true,
                        cql_filter: "sede='Não'"
                    },
                    {
                        codigo: 'AREA_EMBARGADA_RS',
                        nome: 'AREA_EMBARGADA_RS',
                        label: 'Áreas Embargadas - RS',
                        layerName: 'vega-api-homolog:area_embargada_rs',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api-homolog/wms',
                        colorIcon: '#FF0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREAS_EMBARGADAS_TO',
                        nome: 'AREAS_EMBARGADAS_TO',
                        label: 'Áreas Embargadas - TO',
                        layerName: 'vega-api:areas_embargadas_to',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FF0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTO_INFRACAO_TO',
                        nome: 'AUTO_INFRACAO_TO',
                        label: 'Auto de Infração - TO',
                        layerName: 'vega-api:auto_infracao_to',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FFFF00',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTO_INFRACAO_RS',
                        nome: 'AUTO_INFRACAO_RS',
                        label: 'Auto de Infração - RS',
                        layerName: 'vega-api:auto_infracao_rs',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FFFF00',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTO_INFRACAO_PI',
                        nome: 'AUTO_INFRACAO_PI',
                        label: 'Auto de Infração - PI',
                        layerName: 'vega-api:auto_infracao_pi',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FFFF00',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTO_INFRACAO_GO_POLIGONO',
                        nome: 'AUTO_INFRACAO_GO_POLIGONO',
                        label: 'Auto Infração GO Polígono',
                        layerName: 'vega-api:auto_infracao_go_poligono',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#7859C3',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_PA',
                        nome: 'AREA_EMBARGADA_PA',
                        label: 'Áreas Embargadas - PA',
                        layerName: 'vega-api:areas_embargadas_pa',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#B21D11',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_GO_PONTO',
                        nome: 'AREA_EMBARGADA_GO_PONTO',
                        label: 'Área embargada GO - Ponto',
                        layerName: 'vega-api:area_embargada_go_ponto',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FF0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTO_INFRACAO_IPAAM',
                        nome: 'AUTO_INFRACAO_IPAAM',
                        label: 'Auto de Infração IPAAM',
                        layerName: 'vega-api:auto_de_infracao_ipaam',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FFFF00',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTOS_EMBARGOS_IPAAM_POL',
                        nome: 'AUTOS_EMBARGOS_IPAAM_POL',
                        label: 'Avisos de embargo - IPAAM',
                        layerName: 'vega-api:autos_embargos_ipaam_pol',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#FFFF00',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'TERMO_EMBARGO_IPAAM',
                        nome: 'TERMO_EMBARGO_IPAAM',
                        label: 'Termo de embargo - IPAAM',
                        layerName: 'vega-api:termo_embargo_ipaam',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'EMBARGOS_EMERGENCIAIS_IPAAM',
                        nome: 'EMBARGOS_EMERGENCIAIS_IPAAM',
                        label: 'Embargos emergenciais - IPAAM',
                        layerName: 'vega-api:embargos_emergenciais_ipaam',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#7078e4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTOS_INFRACAO_FISCALIZACAO_IPAAM',
                        nome: 'AUTOS_INFRACAO_FISCALIZACAO_IPAAM',
                        label: 'Autos de Infração de Fiscalização - IPAAM',
                        layerName: 'vega-api:autos_infracao_fiscalizacao_ipaam',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'EMBARGOS_REMOTOS_IPAAM',
                        nome: 'EMBARGOS_REMOTOS_IPAAM',
                        label: 'Embargos remotos - IPAAM',
                        layerName: 'vega-api:embargos_remotos_ipaam',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#3a6c77',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AUTO_INFRACAO_GO_PONTO',
                        nome: 'AUTO_INFRACAO_GO_PONTO',
                        label: 'Auto Infração GO Ponto',
                        layerName: 'vega-api:auto_infracao_go_ponto',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AMAZONIA_PROTEGE',
                        nome: 'AMAZONIA_PROTEGE',
                        label: 'Amazônia Protege',
                        layerName: 'vega-api:amazonia_protege',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_CE',
                        nome: 'AREA_EMBARGADA_CE',
                        label: 'Áreas Embargadas (SEMACE)',
                        layerName: 'vega-api:area_embargada_ce',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_CE_PONTO',
                        nome: 'AREA_EMBARGADA_CE_PONTO',
                        label: 'Áreas Embargadas (SEMACE)-Pontos',
                        layerName: 'vega-api:area_embargada_ce_ponto',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_RO',
                        nome: 'AREA_EMBARGADA_RO',
                        label: 'Área Embargada (SEDAM-RO)-Polígono',
                        layerName: 'vega-api:area_embargada_ro',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREA_EMBARGADA_RO_PONTO',
                        nome: 'AREA_EMBARGADA_RO_PONTO',
                        label: 'Área Embargada (SEDAM-RO)-Ponto',
                        layerName: 'vega-api:area_embargada_ro_ponto',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PLANTIO_DESMATAMENTO_RED_FLAG',
                        nome: 'PLANTIO_DESMATAMENTO_RED_FLAG',
                        label: 'Red Flag - Plantio em desmatamento',
                        layerName: 'vega-api:plantio_desmatamento_red_flag',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#6aa84f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'DESMATAMENTO_ARGENTINA_2025',
                        nome: 'DESMATAMENTO_ARGENTINA_2025',
                        label: 'Deforestación VEGA 2025',
                        layerName: 'vega-api:DESMATAMENTO_ARGENTINA_2025',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#6aa84f',
                        opacidade: 100,
                        inspecionar: true,
                        cql_filter: "ano_final>='2025'"
                    }
                ],
                subtitle: []
            },
            {
                label: 'Áreas protegidas',
                chaveTraducao: 'areasProtegidas',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                ativo: false,
                id: 5,
                children: [
                    {
                        codigo: 'UNIDADE_CONSERVACAO_US',
                        nome: 'UNIDADE_CONSERVACAO_US',
                        label: 'Unidades de conservação de uso sustentável',
                        layerName:
                            'vega-api:unidade_conservacao_uso_sustentavel',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f6630b',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'UNIDADE_CONSERVACAO_PI',
                        nome: 'UNIDADE_CONSERVACAO_PI',
                        label: 'Unidades de conservação de proteção integral',
                        layerName:
                            'vega-api:unidade_conservacao_protecao_integral',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AREAS_SILVESTRES_PROTEGIDAS_PARAGUAI',
                        nome: 'AREAS_SILVESTRES_PROTEGIDAS_PARAGUAI',
                        label: 'Áreas Silvestres Protegidas do Paraguai',
                        layerName: 'vega-api:areas_protegidas_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'FLORESTAS_PUBLICAS',
                        nome: 'FLORESTAS_PUBLICAS',
                        label: 'Florestas Públicas',
                        layerName: 'vega-api:florestas_publicas',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#347474',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'APN_SIFAP',
                        nome: 'APN_SIFAP',
                        label: 'Areas Protegidas Nacionales Argentina – SIFAP',
                        layerName: 'vega-api:APN_SIFAP',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#8AA97C',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'APRIA_RESERVA_DE_LA_BIOSFERA',
                        nome: 'APRIA_RESERVA_DE_LA_BIOSFERA',
                        label: 'Areas Protegidas Reconocimiento Internacional Argentina – Reserva de La Biosfera',
                        layerName: 'vega-api:APRIA_RESERVA_DE_LA_BIOSFERA',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#36c356',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'RESERVA_PROVINCIALE',
                        nome: 'RESERVA_PROVINCIALE',
                        label: 'Areas Protegidas Reconocimiento Internacional Argentina – Reserva Provinciale',
                        layerName: 'vega-api:reserva_provinciale',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#8A4E24',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'APRIA_SITIOS_RAMSAR',
                        nome: 'APRIA_SITIOS_RAMSAR',
                        label: 'Areas Protegidas Reconocimiento Internacional Argentina – Sitios Ramsar',
                        layerName: 'vega-api:APRIA_SITIOS_RAMSAR',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#55A7FE',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'APRIA_PATRIMONIO_DA_HUMANIDAD_PUNTOS',
                        nome: 'APRIA_PATRIMONIO_DA_HUMANIDAD_PUNTOS',
                        label: 'Areas Protegidas Reconocimiento Internacional Argentina – Patrimonio da Humanidad - Puntos',
                        layerName:
                            'vega-api:APRIA_PATRIMONIO_DA_HUMANIDAD_PUNTOS',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ef0c0c',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'APP_ARGENTINA_PONTOS',
                        nome: 'APP_ARGENTINA_PONTOS',
                        label: 'Areas Protegidas Provinciales Argentina - Pontos',
                        layerName: 'vega-api:APP_ARGENTINA_PONTOS',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ef0c0c',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'APP_ARGENTINA_POLIGONOS',
                        nome: 'APP_ARGENTINA_POLIGONOS',
                        label: 'Reservas Provinciales',
                        layerName: 'vega-api:APP_ARGENTINA_POLIGONOS',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#38a350',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'APN_AREA_MARINA_PROTEGIDA',
                        nome: 'APN_AREA_MARINA_PROTEGIDA',
                        label: 'Áreas Marinas Protegidas',
                        layerName: 'vega-api:APN_AREA_MARINA_PROTEGIDA',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#5967E6',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'RESERVA_BIOSFERA_PARAGUAI',
                        nome: 'RESERVA_BIOSFERA_PARAGUAI',
                        label: 'Reserva Biosfera Paraguai',
                        layerName: 'vega-api:reserva_biosfera_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#5967E6',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'SITIO_RAMSAR_PARAGUAI',
                        nome: 'SITIO_RAMSAR_PARAGUAI',
                        label: 'Sítio RAMSAR Paraguai',
                        layerName: 'vega-api:sitio_ramsar_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#5967E6',
                        opacidade: 100,
                        inspecionar: true
                    }
                ]
            },
            {
                label: 'Social',
                chaveTraducao: 'social',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                ativo: false,
                id: 6,
                children: [
                    {
                        codigo: 'TERRA_INDIGENA',
                        nome: 'TERRA_INDIGENA',
                        label: 'Terras Indígenas',
                        layerName: 'vega-api:terra_indigena',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#e69138',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'TERRA_INDIGENA_PARAGUAI',
                        nome: 'TERRA_INDIGENA_PARAGUAI',
                        label: 'Terras Indígenas Paraguai',
                        layerName: 'vega-api:terra_indigena_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#e69138',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'INCRA_QUILOMBOLAS',
                        nome: 'INCRA_QUILOMBOLAS',
                        label: 'Comunidades quilombolas',
                        layerName: 'vega-api:quilombolas_incra',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#c1b0ab',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'QUILOMBOLAS_MARANHAO',
                        nome: 'QUILOMBOLAS_MARANHAO',
                        label: 'Quilombolas - Maranhão',
                        layerName: 'vega-api:quilombolas_maranhao',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#c1b0ab',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'QUILOMBOLAS_MARANHAO_BUFFER',
                        nome: 'QUILOMBOLAS_MARANHAO_BUFFER',
                        label: 'Quilombolas - Maranhão Buffer',
                        layerName: 'vega-api:quilombolas_maranhao_buffer',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#c1b0ab',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'QUILOMBOLAS_BA',
                        nome: 'QUILOMBOLAS_BA',
                        label: 'Quilombolas - Bahia',
                        layerName: 'vega-api:quilombolas_ba',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#70cee4',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'INCRA_ASSENTAMENTOS',
                        nome: 'INCRA_ASSENTAMENTOS',
                        label: 'Assentamento Rural',
                        layerName: 'vega-api:assentamentos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#e5be8f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'SITIOS_ARQUEOLOGICOS',
                        nome: 'SITIOS_ARQUEOLOGICOS',
                        label: 'Sítios Arqueológicos',
                        layerName: 'vega-api:sitios_arqueologicos',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#b9770e',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'OTBN_ARGENTINA',
                        nome: 'OTBN_ARGENTINA',
                        label: 'Ordenamiento Territorial de Bosques Nativos – OTBN',
                        layerName: 'vega-api:OTBN_ARGENTINA',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#F6E128',
                        opacidade: 100,
                        inspecionar: true
                    }
                ],
                subtitle: []
            },
            {
                label: 'Vegetação Herbácea Natural',
                chaveTraducao: 'vegetacaoHerbacea',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                ativo: false,
                id: 7,
                children: [
                    {
                        codigo: 'PASTIZAL_PARAGUAI',
                        nome: 'PASTIZAL_PARAGUAI',
                        label: 'Pastagens',
                        layerName: 'vega-api:pastizal_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#e69138',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PASTIZAL_INUNDABLE_PARAGUAI',
                        nome: 'PASTIZAL_INUNDABLE_PARAGUAI',
                        label: 'Pastagens Inundavel Paraguai',
                        layerName: 'vega-api:pastizal_inundable_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#e69138',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PASTIZAL_CONVERTIDO_A_CULTIVO_PARAGUAY',
                        nome: 'PASTIZAL_CONVERTIDO_A_CULTIVO_PARAGUAY',
                        label: 'Pastizal Convertido en Cultivo Agrícola - Paraguay',
                        layerName: 'vega-api:pasto_convertido_para_culturas_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#ff0000',
                        opacidade: 100,
                        inspecionar: true
                    }
                ]
            }
        ]
    },
    {
        label: 'Limites territoriais',
        chaveTraducao: 'limitesTerritoriais',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        ativo: false,
        id: 8,
        children: [
            {
                label: 'Áreas administrativas',
                chaveTraducao: 'areasAdministrativas',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                ativo: false,
                id: 9,
                children: [
                    {
                        codigo: 'BIOMAS',
                        nome: 'BIOMAS',
                        label: 'Biomas',
                        layerName: 'vega-api:biomas',
                        styleName: 'vega-api:biomas-classificados',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#8be365',
                        opacidade: 100,
                        inspecionar: true,
                        subtitle: [
                            {
                                name: 'Amazonia',
                                colorIcon: '#42a72a',
                                opacidade: 100
                            },
                            {
                                name: 'Cerrado',
                                colorIcon: '#fde8a0',
                                opacidade: 100
                            },
                            {
                                name: 'Caatinga',
                                colorIcon: '#f69f8c',
                                opacidade: 100
                            },
                            {
                                name: 'Pantanal',
                                colorIcon: '#a3a189',
                                opacidade: 100
                            },
                            {
                                name: 'Mata Atlântica',
                                colorIcon: '#fbe1fe',
                                opacidade: 100
                            },
                            {
                                name: 'Pampa',
                                colorIcon: '#d3ecb5',
                                opacidade: 100
                            }
                        ]
                    },
                    {
                        codigo: 'BR_LOCALIDADE_NIVEL_1',
                        nome: 'BR_LOCALIDADE_NIVEL_1',
                        label: 'BR_LOCALIDADE_NIVEL_1',
                        layerName: 'vega-api:br_localidade_nivel_1',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'BR_LOCALIDADE_NIVEL_2',
                        nome: 'BR_LOCALIDADE_NIVEL_2',
                        label: 'BR_LOCALIDADE_NIVEL_2',
                        layerName: 'vega-api:br_localidade_nivel_2',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'FAIXA_FRONTEIRA',
                        nome: 'FAIXA_FRONTEIRA',
                        label: 'Faixa de fronteira',
                        layerName: 'vega-api:faixa_fronteira',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                        colorIcon: '#E06666',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PY_LOCALIDADE_NIVEL_2',
                        nome: 'PY_LOCALIDADE_NIVEL_2',
                        label: 'Localidades Paraguai',
                        layerName: 'vega-api:py_localidade_nivel_2',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'PY_LOCALIDADE_NIVEL_1',
                        nome: 'PY_LOCALIDADE_NIVEL_1',
                        label: 'Departamentos Paraguai',
                        layerName: 'vega-api:py_localidade_nivel_1',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'FINCAS_PARAGUAI',
                        nome: 'FINCAS_PARAGUAI',
                        label: 'Fincas Paraguai',
                        layerName: 'vega-api:fincas_paraguai',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'TERRITORIOS',
                        nome: 'TERRITORIOS',
                        label: 'Territórios',
                        layerName:
                            process.env.VUE_APP_LAYER_TERRITORIO +
                            ':territorio',
                        checkbox: true,
                        ativo: false,
                        local: true,
                        path: process.env.VUE_APP_LAYER_TERRITORIO + '/wms',
                        colorIcon: '#0bfb00',
                        opacidade: 100
                    },
                    {
                        codigo: 'AR_LOCALIDADE_NIVEL_1',
                        nome: 'AR_LOCALIDADE_NIVEL_1',
                        label: 'Provincias Argentina',
                        layerName: 'vega-api:ar_localidade_nivel_1',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'AR_LOCALIDADE_NIVEL_2',
                        nome: 'AR_LOCALIDADE_NIVEL_2',
                        label: 'Departamentos Argentina',
                        layerName: 'vega-api:ar_localidade_nivel_2',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'LOCALIDADE_ONCCA_ARGENTINA',
                        nome: 'LOCALIDADE_ONCCA_ARGENTINA',
                        label: 'Localidade Oncca Argentina',
                        layerName: 'vega-api:localidade_oncca_argentina',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        opacidade: 100,
                        inspecionar: true
                    }
                ],
                subtitle: []
            }
        ]
    },
    {
        label: 'Recursos naturais',
        chaveTraducao: 'recursosNaturais',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        ativo: false,
        id: 10,
        children: [
            {
                codigo: 'COBERTURA_SOLO_MAPBIOMAS',
                nome: 'COBERTURA_SOLO_MAPBIOMAS',
                label: 'Cobertura do Solo - Mapbiomas',
                layerName: 'vega-api:cobertura_solo_map_biomas_2021',
                styleName: 'vega-api:cobertura_solo_mapbiomas',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/gwc/service/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: true,
                subtitle: [
                    {
                        name: 'Afloramento Rochoso',
                        colorIcon: '#FF8C00',
                        opacidade: 100
                    },
                    {
                        name: 'Agricultura',
                        colorIcon: '#E974ED',
                        opacidade: 100
                    },
                    {
                        name: 'Algodão beta',
                        colorIcon: '#660066',
                        opacidade: 100
                    },
                    {
                        name: 'Apicum',
                        colorIcon: '#968C46',
                        opacidade: 100
                    },
                    {
                        name: 'Aquicultura',
                        colorIcon: '#29EEE4',
                        opacidade: 100
                    },
                    {
                        name: 'Área Urbanizada',
                        colorIcon: '#AF2A2A',
                        opacidade: 100
                    },
                    {
                        name: 'Arroz',
                        colorIcon: '#982C9E',
                        opacidade: 100
                    },
                    {
                        name: 'Café',
                        colorIcon: '#CCA0D4',
                        opacidade: 100
                    },
                    {
                        name: 'Citrus',
                        colorIcon: '#D082DE',
                        opacidade: 100
                    },
                    {
                        name: 'Campo Alagado e Área Pantanosa',
                        colorIcon: '#45C2A5',
                        opacidade: 100
                    },
                    {
                        name: 'Cana',
                        colorIcon: '#C27BA0',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Campestre',
                        colorIcon: '#B8AF4F',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Florestal',
                        colorIcon: '#006400',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Savânica',
                        colorIcon: '#32CD32',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Perene',
                        colorIcon: '#F3B4F1',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Temporária',
                        colorIcon: '#D5A6BD',
                        opacidade: 100
                    },
                    {
                        name: 'Mangue',
                        colorIcon: '#687537',
                        opacidade: 100
                    },
                    {
                        name: 'Mineração',
                        colorIcon: '#8A2BE2',
                        opacidade: 100
                    },
                    {
                        name: 'Mosaico de Usos',
                        colorIcon: '#FFEFC3',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Áreas não Vegetadas',
                        colorIcon: '#FF99FF',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Formações não Florestais',
                        colorIcon: '#BDB76B',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Perenes',
                        colorIcon: '#CD49E4',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Temporárias',
                        colorIcon: '#E787F8',
                        opacidade: 100
                    },
                    {
                        name: 'Pastagem',
                        colorIcon: '#FFD966',
                        opacidade: 100
                    },
                    {
                        name: 'Praia Duna e Areal',
                        colorIcon: '#DD7E6B',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Arborizada',
                        colorIcon: '#6B9932',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Herbácea',
                        colorIcon: '#66FFCC',
                        opacidade: 100
                    },
                    {
                        name: 'Rio Lago e Oceano',
                        colorIcon: '#0000FF',
                        opacidade: 100
                    },
                    {
                        name: 'Silvicultura monocultura',
                        colorIcon: '#935132',
                        opacidade: 100
                    },
                    {
                        name: 'Soja',
                        colorIcon: '#C59FF4',
                        opacidade: 100
                    }
                ]
            },
            {
                codigo: 'CARS_DECLARADOS',
                nome: 'CARS_DECLARADOS',
                label: 'Áreas declaradas do CAR',
                layerName: 'vega-api:cars_declarados',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                subtitle: [
                    {
                        name: 'APP Total',
                        colorIcon: '#e4ff15',
                        opacidade: 100
                    },
                    {
                        name: 'Área Consolidada',
                        colorIcon: '#616161',
                        opacidade: 100
                    },
                    {
                        name: 'Área Não Classificada',
                        colorIcon: '#ebf0dc',
                        opacidade: 100
                    },
                    {
                        name: 'Hidrografia',
                        colorIcon: '#377eb8',
                        opacidade: 100
                    },
                    {
                        name: "Nascente ou olho d'água perene",
                        colorIcon: '#0000ff',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação Nativa',
                        colorIcon: '#33a02c',
                        opacidade: 100
                    },
                    {
                        name: 'Reserva Legal',
                        colorIcon: '#4d654a',
                        opacidade: 100
                    }
                ]
            },
            {
                codigo: 'COBERTURA_SOLO_MAPBIOMAS_2024',
                nome: 'COBERTURA_SOLO_MAPBIOMAS_2024',
                label: 'Cobertura do Solo - Mapbiomas (coleção 10)',
                layerName: 'vega-api:cobertura_solo_map_biomas_2024',
                styleName: 'vega-api:cobertura_solo_mapbiomas_colecao10',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#8be365',
                opacidade: 100,
                inspecionar: false,
                showOnZoom: 9,
                subtitle: [
                    {
                        name: 'Floresta',
                        colorIcon: '#1f8d49',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Florestal',
                        colorIcon: '#1f8d49',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Savânica',
                        colorIcon: '#7dc975',
                        opacidade: 100
                    },
                    {
                        name: 'Mangue',
                        colorIcon: '#04381d',
                        opacidade: 100
                    },
                    {
                        name: 'Floresta Alagável',
                        colorIcon: '#007785',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Arbórea',
                        colorIcon: '#02d659',
                        opacidade: 100
                    },
                    {
                        name: 'Vegetação Herbácea e Arbustiva',
                        colorIcon: '#d6bc74',
                        opacidade: 100
                    },
                    {
                        name: 'Campo Alagado e Área Pantanosa',
                        colorIcon: '#519799',
                        opacidade: 100
                    },
                    {
                        name: 'Formação Campestre',
                        colorIcon: '#d6bc74',
                        opacidade: 100
                    },
                    {
                        name: 'Apicum',
                        colorIcon: '#fc8114',
                        opacidade: 100
                    },
                    {
                        name: 'Afloramento Rochoso',
                        colorIcon: '#ffaa5f',
                        opacidade: 100
                    },
                    {
                        name: 'Restinga Herbácea',
                        colorIcon: '#ad5100',
                        opacidade: 100
                    },
                    {
                        name: 'Agropecuária',
                        colorIcon: '#ffefc3',
                        opacidade: 100
                    },
                    {
                        name: 'Pastagem',
                        colorIcon: '#edde8e',
                        opacidade: 100
                    },
                    {
                        name: 'Agricultura',
                        colorIcon: '#E974ED',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Temporária',
                        colorIcon: '#C27BA0',
                        opacidade: 100
                    },
                    {
                        name: 'Soja',
                        colorIcon: '#f5b3c8',
                        opacidade: 100
                    },
                    {
                        name: 'Cana',
                        colorIcon: '#db7093',
                        opacidade: 100
                    },
                    {
                        name: 'Arroz',
                        colorIcon: '#c71585',
                        opacidade: 100
                    },
                    {
                        name: 'Algodão (beta)',
                        colorIcon: '#ff69b4',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Temporárias',
                        colorIcon: '#f54ca9',
                        opacidade: 100
                    },
                    {
                        name: 'Lavoura Perene',
                        colorIcon: '#d082de',
                        opacidade: 100
                    },
                    {
                        name: 'Café',
                        colorIcon: '#d68fe2',
                        opacidade: 100
                    },
                    {
                        name: 'Citrus',
                        colorIcon: '#9932cc',
                        opacidade: 100
                    },
                    {
                        name: 'Dendê',
                        colorIcon: '#9065d0',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Lavouras Perenes',
                        colorIcon: '#e6ccff',
                        opacidade: 100
                    },
                    {
                        name: 'Silvicultura',
                        colorIcon: '#7a5900',
                        opacidade: 100
                    },
                    {
                        name: 'Mosaico de Usos',
                        colorIcon: '#ffefc3',
                        opacidade: 100
                    },
                    {
                        name: 'Área não Vegetada',
                        colorIcon: '#d4271e',
                        opacidade: 100
                    },
                    {
                        name: 'Praia Duna e Areal',
                        colorIcon: '#ffa07a',
                        opacidade: 100
                    },
                    {
                        name: 'Área Urbanizada',
                        colorIcon: '#d4271e',
                        opacidade: 100
                    },
                    {
                        name: 'Mineração',
                        colorIcon: '#9c0027',
                        opacidade: 100
                    },
                    {
                        name: 'Outras Áreas não Vegetadas',
                        colorIcon: '#db4d4f',
                        opacidade: 100
                    },
                    {
                        name: 'Corpo Dágua',
                        colorIcon: '#2532e4',
                        opacidade: 100
                    },
                    {
                        name: 'Rio Lago e Oceano',
                        colorIcon: '#2532e4',
                        opacidade: 100
                    },
                    {
                        name: 'Aquicultura',
                        colorIcon: '#091077',
                        opacidade: 100
                    },
                    {
                        name: 'Não observado',
                        colorIcon: '#ffffff',
                        opacidade: 100
                    }
                ]
            }
        ],
        subtitle: []
    },
    {
        label: 'Certificações',
        chaveTraducao: 'certificacoes',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        ativo: false,
        id: 11,
        children: [
            {
                label: 'Renovabio',
                chaveTraducao: 'renovabio',
                icon: 'mdi mdi-folder-outline',
                checkbox: false,
                id: 12,
                children: [
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_RS_2024',
                        nome: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_RS_2024',
                        label: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_RS_2024',
                        layerName:
                            'vega-api:elegibilidade_renovabio_elegivel_rs_2024',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#9ef42f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_RS_2024',
                        nome: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_RS_2024',
                        label: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_RS_2024',
                        layerName:
                            'vega-api:elegibilidade_renovabio_nao_elegivel_rs_2024',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f45f2f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_PR_2024',
                        nome: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_PR_2024',
                        label: 'ELEGIBILIDADE_RENOVABIO_ELEGIVEL_PR_2024',
                        layerName:
                            'vega-api:elegibilidade_renovabio_elegivel_pr_2024',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#9ef42f',
                        opacidade: 100,
                        inspecionar: true
                    },
                    {
                        codigo: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_PR_2024',
                        nome: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_PR_2024',
                        label: 'ELEGIBILIDADE_RENOVABIO_NAO_ELEGIVEL_PR_2024',
                        layerName:
                            'vega-api:elegibilidade_renovabio_nao_elegivel_pr_2024',
                        checkbox: true,
                        ativo: false,
                        path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                        colorIcon: '#f45f2f',
                        opacidade: 100,
                        inspecionar: true
                    }
                ],
                subtitle: []
            },
            {
                codigo: 'DESMATAMENTO_2007',
                nome: 'DESMATAMENTO_2007',
                label: 'Desmatamento 2007',
                layerName: 'vega-api:desmatamento_2007',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2008',
                nome: 'DESMATAMENTO_2008',
                label: 'Desmatamento 2008',
                layerName: 'vega-api:desmatamento_2008',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2009',
                nome: 'DESMATAMENTO_2009',
                label: 'Desmatamento 2009',
                layerName: 'vega-api:desmatamento_2009',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2011',
                nome: 'DESMATAMENTO_2011',
                label: 'Desmatamento 2011',
                layerName: 'vega-api:desmatamento_2011',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2013',
                nome: 'DESMATAMENTO_2013',
                label: 'Desmatamento 2013',
                layerName: 'vega-api:desmatamento_2013',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2015',
                nome: 'DESMATAMENTO_2015',
                label: 'Desmatamento 2015',
                layerName: 'vega-api:desmatamento_2015',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2016',
                nome: 'DESMATAMENTO_2016',
                label: 'Desmatamento 2016',
                layerName: 'vega-api:desmatamento_2016',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2018',
                nome: 'DESMATAMENTO_2018',
                label: 'Desmatamento 2018',
                layerName: 'vega-api:desmatamento_2018',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2020',
                nome: 'DESMATAMENTO_2020',
                label: 'Desmatamento 2020',
                layerName: 'vega-api:desmatamento_2020',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2021',
                nome: 'DESMATAMENTO_2021',
                label: 'Desmatamento 2021',
                layerName: 'vega-api:desmatamento_2021',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2022',
                nome: 'DESMATAMENTO_2022',
                label: 'Desmatamento 2022',
                layerName: 'vega-api:desmatamento_2022',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'DESMATAMENTO_2023',
                nome: 'DESMATAMENTO_2023',
                label: 'Desmatamento 2023',
                layerName: 'vega-api:desmatamento_2023',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ff0000',
                opacidade: 100,
                inspecionar: false
            },
            {
                codigo: 'AREA_PLANTADA_VEGETACAO_NATIVA_2022_MILHO',
                nome: 'AREA_PLANTADA_VEGETACAO_NATIVA_2022_MILHO',
                label: 'Área Plantada (2022/2023 - Milho)',
                layerName: 'vega-api:area_plantada_soja_milho_safra_2022',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#ffd866',
                opacidade: 100,
                cql_filter: "cultura='MILHO'",
                styleName: 'milho',
                inspecionar: true
            },
            {
                codigo: 'AREA_PLANTADA_VEGETACAO_NATIVA_2022_SOJA',
                nome: 'AREA_PLANTADA_VEGETACAO_NATIVA_2022_SOJA',
                label: 'Área Plantada (2022/2023 - Soja)',
                layerName: 'vega-api:area_plantada_soja_milho_safra_2022',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#6aa84f',
                opacidade: 100,
                cql_filter: "cultura='SOJA'",
                styleName: 'soja',
                inspecionar: true
            },
            {
                codigo: 'TREE_CANOPY_COVER_TCC',
                nome: 'TREE_CANOPY_COVER_TCC',
                label: 'Tree canopy cover (TCC)',
                layerName: 'vega-api:tree_canopy_cover',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#e69138',
                opacidade: 100,
                inspecionar: true
            }
        ],
        subtitle: []
    },
    {
        label: 'Red Flag',
        chaveTraducao: 'redFlag',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        ativo: false,
        id: 13,
        children: [
            {
                codigo: 'RED_FLAG',
                nome: 'RED_FLAG_2020',
                label: 'Desmatamento 2020',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2020' AND flag='Red'"
            },
            {
                codigo: 'RED_FLAG',
                nome: 'RED_FLAG_2021',
                label: 'Desmatamento 2021',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2021' AND flag='Red'"
            },
            {
                codigo: 'RED_FLAG',
                nome: 'RED_FLAG_2022',
                label: 'Desmatamento 2022',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2022' AND flag='Red'"
            },
            {
                codigo: 'RED_FLAG',
                nome: 'RED_FLAG_2023',
                label: 'Desmatamento 2023',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2023' AND flag='Red'"
            },
            {
                codigo: 'RED_FLAG',
                nome: 'RED_FLAG_2024',
                label: 'Desmatamento 2024',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2024' AND flag='Red'"
            },
            {
                codigo: 'RED_FLAG',
                nome: 'RED_FLAG_2025',
                label: 'Desmatamento 2025',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2025' AND flag='Red'"
            }
        ],
        subtitle: []
    },
    {
        label: 'Yellow Flag',
        chaveTraducao: 'yellowFlag',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        ativo: false,
        id: 14,
        children: [
            {
                codigo: 'YELLOW_FLAG',
                nome: 'YELLOW_FLAG_2020',
                label: 'Desmatamento 2020',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2020' AND flag='Yellow'"
            },
            {
                codigo: 'YELLOW_FLAG',
                nome: 'YELLOW_FLAG_2021',
                label: 'Desmatamento 2021',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2021' AND flag='Yellow'"
            },
            {
                codigo: 'YELLOW_FLAG',
                nome: 'YELLOW_FLAG_2022',
                label: 'Desmatamento 2022',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2022' AND flag='Yellow'"
            },
            {
                codigo: 'YELLOW_FLAG',
                nome: 'YELLOW_FLAG_2023',
                label: 'Desmatamento 2023',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2023' AND flag='Yellow'"
            },
            {
                codigo: 'YELLOW_FLAG',
                nome: 'YELLOW_FLAG_2024',
                label: 'Desmatamento 2024',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2024' AND flag='Yellow'"
            },
            {
                codigo: 'YELLOW_FLAG',
                nome: 'YELLOW_FLAG_2025',
                label: 'Desmatamento 2025',
                layerName: 'vega-api:red_yellow_flag',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FA0902',
                opacidade: 100,
                inspecionar: true,
                cql_filter: "ano_desmat='2025' AND flag='Yellow'"
            }
        ],
        subtitle: []
    },
    {
        label: 'Footprint',
        chaveTraducao: 'footprint',
        icon: 'mdi mdi-folder-outline',
        checkbox: false,
        ativo: false,
        id: 15,
        children: [
            {
                codigo: 'FOOTPRINT_BUNGE_MOINHO_TRIGO',
                nome: 'MOINHO_TRIGO',
                label: 'Moinho de trigo',
                layerName: 'vega-api:footprint_bunge_moinho_trigo',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#00FFEE',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'FOOTPRINT_BUNGE_SILOS',
                nome: 'SILOS',
                label: 'Silos',
                layerName: 'vega-api:footprint_bunge_silos',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#0000FF',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'FOOTPRINT_BUNGE_PORTO',
                nome: 'PORTO',
                label: 'Porto',
                layerName: 'vega-api:footprint_bunge_porto',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#FF00FF',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'FOOTPRINT_BUNGE_FABRICA',
                nome: 'FABRICA',
                label: 'Fábrica',
                layerName: 'vega-api:footprint_bunge_fabrica',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#A3A300',
                opacidade: 100,
                inspecionar: true
            },
            {
                codigo: 'FOOTPRINT_BUNGE_EDIBLE',
                nome: 'EDIBLE',
                label: 'Edible',
                layerName: 'vega-api:footprint_bunge_edible',
                checkbox: true,
                ativo: false,
                path: 'https://geoserver.vegamonitoramento.com.br/geoserver/vega-api/wms',
                colorIcon: '#9C3B07',
                opacidade: 100,
                inspecionar: true
            }
        ],
        subtitle: []
    }
];

export default camadas;
